import { Injectable } from '@angular/core';

const CSV_TYPE      = 'text/csv;charset=UTF-8;';
const CSV_EXTENSION = '.csv';

@Injectable()
export class ExcelService {

  constructor() { }

  // Single-sheet export (same signature as before)
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const csv = this.jsonToCsv(json);
    this.saveAsCsvFile(csv, excelFileName);
  }

  // Multi-sheet export — each sheet is separated by a header row and a blank line
  public exportAsMultiSheetExcelFile(
    sheets: { name: string; data: any[] }[],
    excelFileName: string
  ): void {
    const parts: string[] = [];

    sheets.forEach(sheet => {
      if (sheet.data && sheet.data.length > 0) {
        parts.push(`"=== ${sheet.name} ==="`);
        parts.push(this.jsonToCsv(sheet.data));
        parts.push('');           // blank line between sheets
      }
    });

    if (parts.length === 0) {
      console.warn('No valid sheets to export');
      return;
    }

    this.saveAsCsvFile(parts.join('\n'), excelFileName);
  }

  // ── Helpers ────────────────────────────────────────────────────────

  private jsonToCsv(json: any[]): string {
    if (!json || json.length === 0) return '';

    const headers = Object.keys(json[0]);

    const escape = (val: any): string => {
      const str = val == null ? '' : val.toString();
      // Wrap in quotes when value contains comma, double-quote, or newline
      return str.includes(',') || str.includes('"') || str.includes('\n')
        ? '"' + str.replace(/"/g, '""') + '"'
        : str;
    };

    const headerRow = headers.map(escape).join(',');
    const dataRows  = json.map(row => headers.map(h => escape(row[h])).join(','));

    return [headerRow, ...dataRows].join('\n');
  }

  private saveAsCsvFile(csv: string, fileName: string): void {
    // UTF-8 BOM (﻿) ensures Excel opens the file with correct encoding
    const blob = new Blob(['﻿' + csv], { type: CSV_TYPE });
    const url  = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href  = url;
    link.setAttribute('download', fileName + 'Prosol_' + new Date().getTime() + CSV_EXTENSION);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
